import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

import useScrollTrigger from '@mui/material/useScrollTrigger';
import useMediaQuery from '@mui/material/useMediaQuery';

import RouteConstants from '../routes';
import AppBarButtons from './AppBarButtons';
import { untrailingSlashIt } from '../utils';

import useStyles from '../styles/Styles';

import _ from 'lodash';

const UmasAppBar = (props) => {
	const classes = useStyles();
	const isSm = useMediaQuery('(min-width:650px)');

	const courseLabels = useSelector(state => state.settings.labels_courses.data);
	const generalSettings = useSelector(state => state.settings.general.data);
	
	const location = useLocation(); 
	const currentRoute = location.pathname === '/' ? RouteConstants.home : _.find(RouteConstants, {path: untrailingSlashIt(location.pathname)});
	
	const [pageTitle, setPageTitle] = useState('');

	useEffect(() => {
		if(!_.isNil(currentRoute)){
			if(currentRoute.title === 'Courses'){
				setPageTitle(courseLabels.coursesCapLabel);
			} else {
				setPageTitle(currentRoute.title);
			}
		} else if (_.startsWith(location.pathname, '/courses/')) {
			const courseCode =  untrailingSlashIt(location.pathname.substr(9));
			setPageTitle(courseLabels.courseCapLabel  + ' Detail: ' + courseCode);
		}
	}, [currentRoute, courseLabels, location])
	
	const trigger = useScrollTrigger({
		disableHysteresis: true,
		//threshold: 100,
		//target: window ? window() : undefined,
	  });
	
	return (
		<AppBar position="fixed" className={trigger ? classes.contextualAppBar : ''}>
			<Toolbar className={classes.toolbar}>
				<IconButton
					color="inherit"
					aria-label="toggle menu"
					edge="start"
					className={classes.menuButton}
					onClick={props.onClick}
				>
				<MenuIcon />
				</IconButton>
				<Typography variant="h6" noWrap>
				{isSm && !trigger ? 'U-MAS - ' : null}
				{trigger && pageTitle !== 'Home' ? 
					pageTitle : 
					generalSettings.display_name}
				</Typography>
				<div className={classes.appBarButtons}>
				<AppBarButtons 
					showCart={isSm}
					isMain={true}
				/>
				</div>
			</Toolbar>
		</AppBar>
	
)}

export default UmasAppBar